import { historyRecordParser } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";
import { IBFRecord } from "@/lib/drivers/insulet/IBFRecords/IBFRecord";
import { IBFRecordParsingInfo } from "@/lib/drivers/insulet/IBFRecords/RecordParser";

export type IBFHistoryLog<T = unknown> = {
  type: number;
  name: string;
  data: T;
};

export const IBF_HISTORY_LOG = (record: IBFRecord, info: IBFRecordParsingInfo): IBFHistoryLog | undefined => {
  record.skip(5);
  const type = record.nextInt32LE();
  // @ts-expect-error - flags intentionally unused
  const _flags = record.nextUInt16LE();
  record.skip(2);

  const data = historyRecordParser(type, record, info);

  if (data) {
    return {
      type,
      ...data,
    };
  }

  return undefined;
};
